__turbopack_context__.v({
  "small": "ticket-link-module-scss-module__Oz9I4q__small",
  "ticket": "ticket-link-module-scss-module__Oz9I4q__ticket",
  "ticket1": "ticket-link-module-scss-module__Oz9I4q__ticket1",
  "ticket2": "ticket-link-module-scss-module__Oz9I4q__ticket2",
  "ticketLabel": "ticket-link-module-scss-module__Oz9I4q__ticketLabel",
  "ticketLink": "ticket-link-module-scss-module__Oz9I4q__ticketLink",
  "tickets": "ticket-link-module-scss-module__Oz9I4q__tickets",
});
